var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$config.platform === 'ds' && _vm.$config.project === 'site' && _vm.$store.state.tests.tests.pricing === 1)?_c('PricingV2',{attrs:{"page-data":_vm.pageData}}):_c('Pricing',{attrs:{"page-data":_vm.pageData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }